import * as React from 'react';
import { FormEvent } from 'react';
import { Dispatch } from 'redux';
import styled from 'styled-components';
import { connect } from 'react-redux';
import {
  Checkbox,
  MessageBar,
  Spinner,
  SpinnerSize,
  Text,
  TextField,
} from 'office-ui-fabric-react';
import { IStackProps, Stack } from 'office-ui-fabric-react';
import buildDate from 'version';

import PrimaryButton from 'views/components/UI/PrimaryButton';

import { IRootState } from 'reducer';
import { IMessage } from 'reducer/messages';
import { actions as userActions } from 'reducer/user';

import { apiErrors }   from 'shared/consts/apiErrors';
import { theme }       from 'theme';
import moment          from 'moment';
import { Capacitor }   from '@capacitor/core';

const AuthWrapper = styled.div`
  background: #f4f4f4;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  row-gap: 48px;
  height: 100vh;
`;

const AuthContainer = styled.div`
  width: 454px;
  margin: 0 auto 0;
  padding-top: 40px;
  border: 1px solid #cccbcb;
  background: #ffffff;
  @media (max-width: 816px) {
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: 100%;
    border: none;

    width: 100%;

    > :first-child {
      margin-top: auto;
    }
  }
`;

const AuthTitle = styled.div`
  min-height: 48px;
  text-align: center;
`;

const AuthDescription = styled.div`
  min-height: 31px;
  margin-bottom: 8px;
  text-align: center;
  vertical-align: top;
`;

const Copyright = styled.div`
  min-height: 20px;
  margin-bottom: 25px;
  text-align: center;
  vertical-align: top;

  @media (max-width: 816px) {
    bottom: 5px;
    margin: auto 0 8px;
    width: 100%;
  }
`;

const columnProps: Partial<IStackProps> = {
  tokens: {
    childrenGap: 8,
  },
  styles: {
    root: {
      width: 200,
      margin: '0 auto',
    },
  },
};

const buttonProps = {
  styles: {
    root: {
      background:'#003c97',
    },
  },
};

interface IProps {
  onUserLogin: (email: string, password: string) => void;
  isLoginProcessing: boolean;
  isLogged: boolean;
  messagesStack: Array<IMessage>;
}

interface IState {
  shouldErrorMessageAppear: boolean;
  isError: boolean;
  authForm: {
    username: string;
    password: string;
  };
}

class AuthPage extends React.Component<IProps, IState> {
  state = {
    shouldErrorMessageAppear: false,
    isError: false,
    authForm: {
      username: '',
      password: '',
    },
  };

  private usernameChangeHandler = (event: React.SyntheticEvent): void => {
    const target = event.target as HTMLInputElement;
    const newAuthForm = { ...this.state.authForm };
    newAuthForm.username = target.value;
    this.setState({
      authForm: newAuthForm,
    });
  };

  private passwordChangeHandler = (event: React.SyntheticEvent): void => {
    const target = event.target as HTMLInputElement;
    const newAuthForm = { ...this.state.authForm };
    newAuthForm.password = target.value;
    this.setState({
      authForm: newAuthForm,
    });
  };


  private authHandler = (event: FormEvent<HTMLFormElement>): void => {
    event.preventDefault();
    if (this.state.isError) {
      return;
    }
    if (!this.state.authForm.username || !this.state.authForm.password) {
      this.setState({
        shouldErrorMessageAppear: true,
      });
    } else {
      this.props.onUserLogin(
        this.state.authForm.username,
        this.state.authForm.password,
      );
    }
  };

  render() {
    const { authForm, shouldErrorMessageAppear } = this.state;

    const { isLoginProcessing, messagesStack } = this.props;

    // @ts-ignore
    // const logo = typeof window.cordova !== "undefined"? window.cordova.file.applicationDirectory + "www/logo.svg": LogoImg;
    // const logo = typeof window.cordova !== "undefined"? window.cordova.file.applicationDirectory + "www/logo.png": LogoImg;

    return (
      <AuthWrapper>
        {
          process.env.REACT_APP_KSHS_CLIENT ?
            <div>
              <img src='/KSHS_logo.svg' />
            </div>
            :
            <div style={{width: 382, height: 42}}>
              <img style={{ objectFit: 'cover', width: '100%', height: '100%' }} src={"/ttm-logo_rus_gradient_v1.svg"} alt={'Логотип'}/>
            </div>
        }
        <AuthContainer>
          {
            !process.env.REACT_APP_KSHS_CLIENT &&
            <AuthDescription>
              <Text variant="large">Универсальная мультисервисная платформа</Text>
            </AuthDescription>
          }
          <AuthTitle>
            <Text variant="xxLarge">Авторизация</Text>
          </AuthTitle>
          <AuthDescription>
            <Text variant="large">Введите свои данные</Text>
          </AuthDescription>
          <form onSubmit={this.authHandler}>
            <Stack {...columnProps}>
              <TextField
                value={authForm.username}
                onChange={this.usernameChangeHandler}
                placeholder="Логин"
                errorMessage={
                  shouldErrorMessageAppear && !authForm.username
                    ? 'Это обязательное поле'
                    : ''
                }
                disabled={isLoginProcessing}
              />
              <TextField
                value={authForm.password}
                onChange={this.passwordChangeHandler}
                errorMessage={
                  shouldErrorMessageAppear && !authForm.password
                    ? 'Это обязательное поле'
                    : ''
                }
                placeholder="Пароль"
                type="password"
                disabled={isLoginProcessing}
              />
              <PrimaryButton
                {...buttonProps}
                type={'submit'}
                disabled={isLoginProcessing}
                styles={{
                  root: {
                    marginBottom: 12,
                    backgroundColor: '#003c97',
                  },
                }}
              >
                Вход
              </PrimaryButton>
            </Stack>
          </form>

          <Copyright>
            <Text variant="xSmall">@ Copyright {new Date().getFullYear()}</Text>
          </Copyright>
          {Capacitor.isNative && (
            <Copyright>
              <Text variant="xSmall">
                Версия приложения от{' '}
                {moment(buildDate).format('DD.MM.yyyy HH:mm')}
              </Text>
            </Copyright>
          )}
          {!isLoginProcessing && !!messagesStack.length && (
            <MessageBar
              styles={{
                root: {
                  width: 300,
                  margin: '0 auto 25px',
                },
                iconContainer: {
                  display: 'none',
                },
                text: {
                  display: 'flex',
                  justifyContent: 'center',
                  textAlign: 'center',
                },
              }}
              messageBarType={1}
            >
              {((message) =>
                message
                  ? apiErrors[message]
                    ? apiErrors[message]
                    : message.toLocaleUpperCase()
                  : ' ')(messagesStack[0].messages![0])}
            </MessageBar>
          )}
          {isLoginProcessing && (
            <Spinner
              styles={{
                root: {
                  marginBottom: '28px',
                },
              }}
              size={SpinnerSize.large}
            />
          )}
        </AuthContainer>
      </AuthWrapper>
    );
  }
}

const mapStateToProps = ({ user, messages }: IRootState) => ({
  isLoginProcessing: user.isProcessing,
  isLogged: user.isLogged,
  messagesStack: messages.messagesStack,
});

const mapActionsToProps = (dispatch: Dispatch) => ({
  onUserLogin: (email: string, password: string) => {
    const method = 'performLogin';
    return dispatch(
      userActions[method]({
                            username: email,
                            password: password,
                          }));
  },
});

export default connect(mapStateToProps, mapActionsToProps)(AuthPage);
